import { BrowserRouter } from 'react-router-dom'

import { AuthProvider } from '@/contexts/auth'
import { CompaniesProvider } from '@/contexts/companies'

import { ErrorBoundary } from './error-boundary'
import { QueryClientProvider } from './query-client-provider'
import { ThemeProvider } from './theme-provider'

type GlobalProviderProps = {
  children: React.ReactNode
}

export const GlobalProvider = ({ children }: GlobalProviderProps) => {
  const components = [
    ThemeProvider,
    ErrorBoundary,
    BrowserRouter,
    QueryClientProvider,
    AuthProvider,
    CompaniesProvider,
  ]

  return (
    <>
      {components.reduceRight((acc, Component) => {
        return <Component>{acc}</Component>
      }, children)}
    </>
  )
}
